export function getFirstNumber(str) {
  const match = str.match(/\d+/);
  if (match) {
    const returnData = parseInt(match[0], 10);
    return returnData;
  } else {
    return 0;
  }
}
